/**
 * The agent answered, but not with a draft: it asked a question, said the request can't be
 * expressed, or the request was off-topic. Shown as a message to the user, not as a failure.
 */
export class SegmentAiReplyError extends Error {
  readonly reply: string;

  constructor(reply: string) {
    super(reply);
    this.name = 'SegmentAiReplyError';
    this.reply = reply;
    Object.setPrototypeOf(this, SegmentAiReplyError.prototype);
  }
}

const looksLikeRawPayload = (message: string) => /^\s*[{[]/.test(message);

/** Turns transport and API failures into something a marketer can act on. */
export const getSegmentAiErrorMessage = (error: unknown): string => {
  const status =
    typeof error === 'object' && error !== null && 'status' in error
      ? Number((error as { status: unknown }).status)
      : NaN;
  const message = error instanceof Error ? error.message : '';

  if (status === 401 || status === 403) {
    return 'Your session expired or you don’t have access to the segmentation agent. Reload the page and try again.';
  }
  if (status === 429) {
    return 'Too many requests right now. Wait a moment and try again.';
  }
  if (status >= 500 || /network error/i.test(message) || /failed to fetch/i.test(message)) {
    return 'Couldn’t reach the segmentation agent. Try again in a moment.';
  }
  if (!message || looksLikeRawPayload(message)) {
    return 'Something went wrong while generating the segment. Try again.';
  }
  return message;
};
